import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 8h18","key":"svg-0"}],["path",{"d":"M3 16h18","key":"svg-1"}],["path",{"d":"M8 3v18","key":"svg-2"}],["path",{"d":"M16 3v18","key":"svg-3"}]]

/**
 * IconGrid3x3
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZ3JpZC0zeDMiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTMgOGgxOCIgLz4KICA8cGF0aCBkPSJNMyAxNmgxOCIgLz4KICA8cGF0aCBkPSJNOCAzdjE4IiAvPgogIDxwYXRoIGQ9Ik0xNiAzdjE4IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/grid-3x3
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconGrid3x3 = createReactComponent('outline', 'grid-3x3', 'Grid3x3', __iconNode);

export default IconGrid3x3;